module.exports = __webpack_public_path__ + "img/af865e0.jpg";